import {
  GET_AGENT_EXCHANGE_RATE_FAILURE,
  GET_AGENT_EXCHANGE_RATE_STARTED,
  GET_AGENT_EXCHANGE_RATE_SUCCESS,
  GET_AGENT_TRANSACTIONS_FAILURE,
  GET_AGENT_TRANSACTIONS_STARTED,
  GET_AGENT_TRANSACTIONS_SUCCESS,
  GET_AGENTS_BALANCES_FAILURE,
  GET_AGENTS_BALANCES_STARTED,
  GET_AGENTS_BALANCES_SUCCESS,
  GET_AGENTS_LIST_FAILURE,
  GET_AGENTS_LIST_STARTED,
  GET_AGENTS_LIST_SUCCESS,
  SET_AGENT,
  UPDATE_AGENT_FAILURE,
  UPDATE_AGENT_STARTED,
  UPDATE_AGENT_SUCCESS,
} from "redux/ActionTypes";
import {
  deleteDefaultWalletAPI,
  getAgentExchangeRateAPI,
  getAgentsBalancesAPI,
  getAgentsListAPI,
  getAgentTransactionsAPI,
  updateAgentAPI,
} from "services/API/agent";
import { getUserDefaultsRequestAction } from "./usersActions";
import { showMessage } from "components/Modal";
// --------------------------------------------------------------------------------
export const getAgentsListStartedAction = () => ({
  type: GET_AGENTS_LIST_STARTED,
});

export const getAgentsListSuccessAction = (payload) => ({
  type: GET_AGENTS_LIST_SUCCESS,
  payload,
});

export const getAgentsListFailureAction = (message) => ({
  type: GET_AGENTS_LIST_FAILURE,
  payload: message,
});

// --------------------------------------------------------------------------------
export const setAgent = (agent) => ({
  type: SET_AGENT,
  payload: agent,
});

// --------------------------------------------------------------------------------
export const getAgentTransactionsRequestAction = ({ limit, offset }) => {
  return async (dispatch) => {
    dispatch(getAgentTransactionsStartedAction());
    try {
      let response = await getAgentTransactionsAPI({ limit, offset });
      if (!response.error) {
        dispatch(
          getAgentTransactionsSuccessAction({
            transactions: response.data,
          })
        );
      } else {
        dispatch(
          getAgentTransactionsFailureAction(response.data.error_message)
        );
      }
    } catch (error) {
      dispatch(getAgentTransactionsFailureAction(error.error_message));
    }
  };
};

export const getAgentTransactionsStartedAction = () => ({
  type: GET_AGENT_TRANSACTIONS_STARTED,
});

export const getAgentTransactionsSuccessAction = (payload) => ({
  type: GET_AGENT_TRANSACTIONS_SUCCESS,
  payload,
});

export const getAgentTransactionsFailureAction = (message) => ({
  type: GET_AGENT_TRANSACTIONS_FAILURE,
  payload: message,
});

export const getAgentsBalancesAction = ({ setBalances }) => {
  return async (dispatch) => {
    dispatch(getAgentsStartedAction());
    try {
      let response = await getAgentsBalancesAPI();
      if (!response.error) {
        dispatch(getAgentsSuccessAction());
        setBalances(response.data);
      } else {
        dispatch(getAgentsFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(getAgentsFailureAction(error.error_message));
    }
  };
};

export const getAgentsStartedAction = () => ({
  type: GET_AGENTS_BALANCES_STARTED,
});

export const getAgentsSuccessAction = (payload) => ({
  type: GET_AGENTS_BALANCES_SUCCESS,
  payload,
});

export const getAgentsFailureAction = (message) => ({
  type: GET_AGENTS_BALANCES_FAILURE,
  payload: message,
});

// --------------------------------------------------------------------------------
export const getAgentExchangeRateRequestAction = () => {
  return async (dispatch) => {
    dispatch(getAgentExchangeRateStartedAction());
    try {
      let response = await getAgentExchangeRateAPI();
      if (response.status) {
        dispatch(
          getAgentExchangeRateSuccessAction({
            agentExchangeRate: response.data,
          })
        );
      } else {
        dispatch(
          getAgentExchangeRateFailureAction(response.data.error_message)
        );
      }
    } catch (error) {
      showMessage({
        description: error.error_message,
        status: "error",
      });
      dispatch(getAgentExchangeRateFailureAction(error.error_message));
    }
  };
};

export const getAgentExchangeRateStartedAction = () => ({
  type: GET_AGENT_EXCHANGE_RATE_STARTED,
});

export const getAgentExchangeRateSuccessAction = (payload) => ({
  type: GET_AGENT_EXCHANGE_RATE_SUCCESS,
  payload,
});

export const getAgentExchangeRateFailureAction = (message) => ({
  type: GET_AGENT_EXCHANGE_RATE_FAILURE,
  payload: message,
});
